import { Yup } from '../../common/CommonExport';
import { ErrorMessages } from '../../constants/messagesAndErrors';

export const LoginFormSchema = Yup.object({
    email: Yup.string().email(ErrorMessages.invalidEmail).required(ErrorMessages.enterEmail),
    password: Yup.string().trim(ErrorMessages.invalidPassword).strict(true).required(ErrorMessages.enterPassword).max(30, ErrorMessages.maxPasswordAllowed),
});
